export default "__VITE_ASSET__DcOrhlqY__"